<template>
    <div>
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card>
            <v-card-title class="toolbar">
                Routewise Transport Attendance Report
            </v-card-title>

            <v-card-text>
                <v-row justify="center" class="mt-2">
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="selected_route" :items="route_list" item-text="route" item-value="id"
                            @change="getvehicle()" outlined rounded required>
                            <template #label>
                                Route <span style="color: red;"> *</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-autocomplete v-model="selected_vehicle" :items="vehicle_list" item-text="name"
                            item-value="id" outlined rounded required>
                            <template #label>
                                vehicle <span style="color: red;"> *</span>
                            </template>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center">
                    <v-col cols="12" sm="3" md="2">
                        <v-checkbox v-model="selected_transport_in" color="primary">
                            <template #label>
                                Transport-In <span style="color: red;"> *</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="3" md="2">
                        <v-checkbox v-model="selected_transport_out" color="primary">
                            <template #label>
                                Transport-Out <span style="color: red;"> *</span>
                            </template>
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center">
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="selected_from_date" rounded outlined type="date">
                            <template #label>
                                From date<span style="color: red;">*</span> (inclusive)
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field v-model="selected_to_date" rounded outlined type="date">
                            <template #label>
                                To date<span style="color: red;">*</span> (inclusive)
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center">
                    <v-btn rounded class="button" :loading="loader" @click="getAllReport">
                        Fetch
                    </v-btn>
                </v-row>
            </v-card-text>
            <div v-if="attendanceList.length != 0" id="my-table-id" class="ma-3">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Routewise Transport Learner Attendance Report</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field class=" pr-5 no-display" background-color="white" v-model="search"
                        append-icon="mdi-magnify" label="Search by Student Name or Registration Number" single-line
                        hide-details></v-text-field>
                    <v-btn small class="mr-5" color="success" @click="generateAttendancePdf" :loading="loader">
                        <v-icon small color="white">mdi-file-pdf-box</v-icon>
                        <span class="btn-text">PDF</span>
                    </v-btn>
                    <v-btn small color="success" @click="exportAttendanceData" :loading="loader">
                        <v-icon small color="white">mdi-export</v-icon>
                        <span class="btn-text">Export</span>
                    </v-btn>
                </v-toolbar>
                <v-data-table class="elevation-1 mytable " :headers="computedHeaders" :items="filteredAttendanceList"
                    :items-per-page="10" dense>
                    <!-- Custom row template -->
                    <template v-slot:item="{ item, index }">
                        <tr :class="{ 'highlight-row': item.isMismatch }">
                            <td>{{ index + 1 }}</td>
                            <td>{{ item.prn }}</td>
                            <td>{{ item.student_name }}</td>
                            <td>{{ item.standard }}</td>
                            <td>{{ item.division }}</td>
                            <td>{{ item.mapped_route_no }}</td>
                            <td>{{ item.mapped_vehicle_no }}</td>
                            <td>{{ item.attendance_date ? new Date(item.attendance_date).toLocaleDateString('en-GB') :
                                '--' }}</td>
                            <td v-if="selected_transport_in">{{ item.in_route }}</td>
                            <td v-if="selected_transport_in">{{ item.in_vehicle_no }}</td>
                            <td v-if="selected_transport_in">{{ formatTime(item.in_time) }}</td>
                            <td v-if="selected_transport_in">{{ item.inby || '--' }}</td>
                            <td v-if="selected_transport_in">{{ item.in_remark }}</td>
                            <td v-if="selected_transport_out">{{ item.out_route }}</td>
                            <td v-if="selected_transport_out">{{ item.out_vehicle_no }}</td>
                            <td v-if="selected_transport_out">{{ formatTime(item.out_time) }}</td>
                            <td v-if="selected_transport_out">{{ item.outby || '--' }}</td>
                            <td v-if="selected_transport_out">{{ item.out_remark }}</td>
                        </tr>
                    </template>

                </v-data-table>
            </div>
        </v-card>
    </div>
</template>

<script>
    import axios from "axios";
    import "@/assets/css/color.css";
    import jsPDF from "jspdf";
    import "jspdf-autotable";

    export default {
        data() {
            return {
                loader: false,
                color: "",
                snackbar: false,
                snackbar_msg: null,
                selected_route: "",
                selected_vehicle: [],
                selected_transport_in: true,
                selected_transport_out: true,
                selected_from_date: new Date().toISOString().slice(0, 10),
                selected_to_date: new Date().toISOString().slice(0, 10),
                selected_all_route: true,
                search: null,
                route_list: [],
                vehicle_list: [],
                attendanceList: [],
            };
        },

        mounted() {
            this.onload();
        },
        computed: {
            // Dynamically show/hide columns

            computedHeaders() {
                let baseHeaders = [
                    { text: "Sr. No.", value: "srno", sortable: false },
                    { text: "PRN", value: "prn" },
                    { text: "Student Name", value: "student_name" },
                    { text: "Standard", value: "standard" },
                    { text: "Division", value: "division" },
                    { text: "Mapped Route No", value: "mapped_route" },
                    { text: "Mapped Vehicle No", value: "mapped_vehicle_no" },
                    { text: "Date", value: "attendance_date" },
                ];
                if (this.selected_transport_in) {
                    baseHeaders.push({ text: "In Route No", value: "in_route" });
                    baseHeaders.push({ text: "In Vehicle No", value: "in_vehicle_no" });
                    baseHeaders.push({ text: "In Time", value: "in_time" });
                    baseHeaders.push({ text: "In By", value: "inby" });
                    baseHeaders.push({ text: "In Remark", value: "in_remark" });
                }
                if (this.selected_transport_out) {
                    baseHeaders.push({ text: "Out Route No", value: "out_route" });
                    baseHeaders.push({ text: "Out Vehicle No", value: "out_vehicle_no" });
                    baseHeaders.push({ text: "Out Time", value: "out_time" });
                    baseHeaders.push({ text: "Out By", value: "outby" });
                    baseHeaders.push({ text: "Out Remark", value: "out_remark" });

                }

                return baseHeaders;
            },
            // Row filtering (same logic as before)
            filteredAttendanceList() {
                return this.attendanceList.filter(item => {
                    // ✅ Search filter
                    if (this.search && !(
                        (item.prn && item.prn.toLowerCase().includes(this.search.toLowerCase())) ||
                        (item.student_name && item.student_name.toLowerCase().includes(this.search.toLowerCase()))
                    )) {
                        return false;
                    }
                    if (this.selected_transport_in && this.selected_transport_out) {
                        return true;
                    }
                    if (this.selected_transport_in && !this.selected_transport_out) {
                        return !!item.in_time;
                    }
                    if (!this.selected_transport_in && this.selected_transport_out) {
                        return !!item.out_time;
                    }
                    return false;
                });
            }
        },

        methods: {
            generateAttendancePdf() {
                try {
                    const headersArr = this.computedHeaders;
                    const exportData = this.filteredAttendanceList.map((item, index) => {
                        const row = {};
                        headersArr.forEach(h => {
                            if (h.value === "srno") {
                                row[h.value] = index + 1;
                            } else if (h.value === "attendance_date") {
                                row[h.value] = item[h.value]
                                    ? new Date(item[h.value]).toLocaleDateString("en-GB")
                                    : "-";
                            } else if (h.value === "in_time" || h.value === "out_time") {
                                row[h.value] = item[h.value]
                                    ? new Date(item[h.value]).toLocaleTimeString("en-US", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true
                                    })
                                    : "--";
                            } else {
                                row[h.value] = (item[h.value] !== undefined && item[h.value] !== null)
                                    ? item[h.value]
                                    : "--";
                            }
                        });
                        return row;
                    });

                    const doc = new jsPDF({
                        orientation: "landscape",
                        unit: "mm",
                        format: "a4"
                    });

                    const columns = headersArr.map(h => ({
                        header: h.text,
                        dataKey: h.value,
                    }));

                    doc.autoTable({
                        theme: "grid",
                        columns: columns,
                        body: exportData,
                        margin: { top: 5, right: 5, bottom: 5, left: 5 },
                        styles: {
                            fontSize: 6,          // ✅ smaller font size
                            cellPadding: 0.6,
                            overflow: "linebreak", // ✅ wrap text, no "..."
                            halign: "center",
                            valign: "middle",
                        },
                        columnStyles: {
                            srno: { cellWidth: 7 },
                            prn: { cellWidth: 17 },
                            student_name: { cellWidth: 25 },
                            standard: { cellWidth: 12 },
                            division: { cellWidth: 10 },
                            attendance_date: { cellWidth: 18 },
                            mapped_route: { cellWidth: 18 },
                            selected_route: { cellWidth: 15 },
                            in_time: { cellWidth: 15 },
                            out_time: { cellWidth: 15 },
                            in_by: { cellWidth: 38 },   // ✅ enough width for full text
                            out_by: { cellWidth: 38 },  // ✅ enough width for full text
                        },
                        headStyles: {
                            fillColor: [0, 128, 0],
                            textColor: [255, 255, 255],
                            fontSize: 6,
                            cellPadding: 0.8,
                            halign: "center",
                            valign: "middle",
                        },
                        bodyStyles: {
                            fontSize: 6,
                            cellPadding: 0.6,
                            overflow: "linebreak", // ✅ wrap full text
                        },
                    });

                    doc.save("RoutewiseAttendanceReport.pdf");
                } catch (err) {
                    console.error("PDF generation error:", err);
                    this.showSnackbar("error", "Failed to generate attendance PDF");
                }
            },


            exportAttendanceData() {
                try {
                    // ✅ Headers from computed property
                    const headersArr = this.computedHeaders;
                    const headerTexts = headersArr.map(h => h.text);

                    // ✅ Prepare data rows
                    const exportData = this.filteredAttendanceList.map((item, index) => {
                        const row = {};
                        headersArr.forEach(h => {
                            if (h.value === "srno") {
                                row[h.text] = index + 1;
                            }
                            else if (h.value === "attendance_date") {
                                // Format date as DD/MM/YYYY
                                row[h.text] = item[h.value]
                                    ? new Date(item[h.value]).toLocaleDateString("en-GB")
                                    : "-";
                            }
                            else if (h.value === "in_time" || h.value === "out_time") {
                                // Format time as 04:37 PM
                                row[h.text] = item[h.value]
                                    ? new Date(item[h.value]).toLocaleTimeString("en-US", {
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true
                                    })
                                    : "-";
                            }
                            else {
                                row[h.text] = (item[h.value] !== undefined && item[h.value] !== null)
                                    ? item[h.value]
                                    : "-";
                            }
                        });
                        return row;
                    });

                    // ✅ Export to Excel
                    import("xlsx").then(XLSX => {
                        const worksheet = XLSX.utils.json_to_sheet(exportData, { header: headerTexts });
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Attendance");
                        XLSX.writeFile(workbook, "Attendance_List.xlsx");
                    });
                } catch (err) {
                    console.error("Export error:", err);
                    this.showSnackbar("error", "Failed to export attendance data");
                }
            },

            showSnackbar(color, msg) {
                this.snackbar = true;
                this.color = color;
                this.snackbar_msg = msg;
            },

            async onload() {
                const res = await axios.post("/TransportLearnerAttendance/getRouteList");
                if (res.data.msg === "200") {
                    this.route_list = res.data.route_list;
                } else {
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            },
            async getvehicle() {
                const payload = {
                    route_id: this.selected_route,
                };
                const res = await axios.post("/TransportLearnerAttendance/getvehicleListFromRoute", payload);
                if (res.data.msg === "200") {
                    this.vehicle_list = res.data.vehiclesList;
                    this.selected_vehicle = this.vehicle_list[0].id;
                } else {
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            },

            async getAllReport() {
                if (!this.selected_route) {
                    this.showSnackbar("error", "Please select route");
                    return;
                }


                this.loader = true;
                this.attendanceList = [];

                let selectedVehicleValue;

                // ✅ If "All" is selected, send all vehicle IDs except null (id: null)
                if (this.selected_vehicle === null) {
                    selectedVehicleValue = this.vehicle_list
                        .filter(v => v.id !== null) // exclude the "All" option
                        .map(v => v.id);
                } else {
                    selectedVehicleValue = this.selected_vehicle; // send single vehicle ID
                }
                const payload = {
                    selected_route: this.selected_route,
                    selected_vehicle: selectedVehicleValue,
                    selected_from_date: this.selected_from_date,
                    selected_to_date: this.selected_to_date,
                };

                const res = await axios.post("/TransportLearnerAttendance/getRouteWiseTransportAttendanceReport", payload);

                if (res.data.msg === "200") {
                    // this.showSnackbar("success", "Report fetched successfully");
                    this.attendanceList = res.data.attendanceList;
                    this.loader = false;

                } else {
                    this.loader = false;
                    this.showSnackbar("error", res.data.msg || "Failed to fetch report");
                }

            },
            formatTime(value) {
                if (!value) return "";
                const date = new Date(value);
                return date.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true   // 👈 ensures AM/PM is added
                });
            },
        }
    };
</script>
<style>
    @media (max-width: 600px) {
        .btn-text {
            display: none;
            padding: 0px;
        }

        .btn {}
    }

    .highlight-row {
        background-color: #B2EBF2 !important;
    }
</style>